import type { ReactNode } from "react";

export interface FrameFooterProps {
  children: ReactNode;
}

/**
 * Optional footer slot rendered after the columns (panes + main) inside the page
 * scroller. On split-view pages the footer is revealed once the user scrolls past
 * the columns; on single-column pages it pins to the viewport bottom on short
 * content and follows in overflow on tall content. The BottomBar (when present)
 * overlays it on mobile.
 */
export function FrameFooter({ children }: FrameFooterProps) {
  return <>{children}</>;
}
